module.exports = __webpack_public_path__ + "img/no-photo.65b48939.jpg";